import { Navigate } from "react-router-dom";
import Home from "../pages/home";
import NotFound from "../pages/notFound";
import JobDetail from "../pages/jobDetail";
import JobHistory from "../pages/jobHistory";
import ApplicantProfile from "../pages/applicantProfile";
import RefreshData from "../pages/clear";

const MainRoutes = [
    {
        path: '/',
        element: <Home />,
    },
    {
        path: '/:org',
        element: <Home />
    },
    {
        path: '/JobDetail/:org/:jobId',
        element: <JobDetail />
    },
    {
        path: '/MyJob',
        element: <JobHistory />
    },
    {
        path: '/ApplicantProfile',
        element: <ApplicantProfile />
    },
    {
        path: '/RefreshData',
        element: <>{<RefreshData />}</>
    },
    {
        path: '/NotFound',
        element: <NotFound />
    },
    {
        path: '*',
        element: <Navigate to="/" replace />
    },
]
export default MainRoutes